import { InputFieldV5 } from "components/form";

const INPUT_FIELDS = [
  {
    name: "email",
    group: "register",
    type: "email",
    icon: "fa fa-envelope",
    className: "input ",
    component: InputFieldV5,
    required: true,
  },
  {
    name: "email2",
    group: "register",
    type: "email",
    icon: "fa fa-envelope",
    className: "input ",
    component: InputFieldV5,
    required: true,
  },
];

export { INPUT_FIELDS };
